<div
    class="wudo-card"
    [ngClass]="{ 'flat-top': flatTop, 'flat-bottom': flatBottom }"
    [style.margin-top]="marginTop"
    [style.margin-bottom]="marginBottom"
>
    <ng-content></ng-content>
</div>
